import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <ul class="notifications" ng-if="vm.show">
            <li ng-class="{unread: item.status === 'NOT_READ'}" ng-repeat="item in vm.notifications">
                <a href="#">{{item.body}}</a>
            </li>
            <li class="more">
                <ul class="actions01 small center nomargin">
                    <li class="nomargin"><a class="btn discrete" ui-sref="authorized.notifications()">View all notifications</a></li>
                </ul>
            </li>
        </ul>
    `,
    bindings: {
        show: '=',
        notifications: '='
    }
})
export default class {
    constructor (NotificationResource) {
        NotificationResource.markAsRead();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/private/notifications/index.js